import React from "react";
import PropTypes from "prop-types";
import {isKeycloakAuthEnabled} from "@breachrx/client-auth";
import LoginProvider from "./LoginProvider";
import KeycloakLoginProvider from "./KeycloakLoginProvider";

export const AuthWrapper = ({children}) => {
  if (isKeycloakAuthEnabled()) {
    return <KeycloakLoginProvider>{children}</KeycloakLoginProvider>;
  }
  return <LoginProvider>{children}</LoginProvider>;
};

AuthWrapper.propTypes = {
  children: PropTypes.node,
};

export default AuthWrapper;
